import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import {
  CONTEXT_NAMES,
  getOrCreateGlobalContext
} from '@adsk/bim360-matrix-react-helpers/es/globalContexts';

import IdleTimeManager from '../helpers/idleTimeManager';

const idleTimeManager = new IdleTimeManager();
const IdleTimeContext = getOrCreateGlobalContext(CONTEXT_NAMES.IdleTimeContext);
const useIdleTime = () => useContext(IdleTimeContext);

const IdleTimeProvider = ({ isFedRAMP, children }) => {
  React.useEffect(() => {
    idleTimeManager.update({ isFedRAMP });
  }, [isFedRAMP]);

  return <IdleTimeContext.Provider value={idleTimeManager}>{children}</IdleTimeContext.Provider>;
};

IdleTimeProvider.propTypes = {
  isFedRAMP: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export { IdleTimeContext as default, IdleTimeProvider, useIdleTime };
